(function () {
  const GIFT_RULES = window.GIFT_RULES || [];
  if (!GIFT_RULES.length) return;

  let isSyncing = false;
  let pollTimer = null;

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function triggerCartUpdate() {
    // Pub/Sub nativo do Trade/Dawn
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
    }
    // Fallback: eventos DOM
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));

    // Fallback: força re-render do cart-drawer-items via fetch de seção
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
      cartDrawerItems.onCartUpdate();
    }
  }

  async function syncGifts() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const cart = await getCart();
      const variantIds = cart.items.map(i => i.variant_id);
      let changed = false;

      for (const rule of GIFT_RULES) {
        const hasTrigger = variantIds.includes(rule.trigger);
        const hasGift    = variantIds.includes(rule.gift);

        if (hasTrigger && !hasGift) {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: rule.gift, quantity: 1 }] }),
          });
          changed = true;
        } else if (!hasTrigger && hasGift) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: rule.gift, quantity: 0 }),
          });
          changed = true;
        }
      }

      if (changed) {
        triggerCartUpdate();
      }
    } finally {
      isSyncing = false;
    }
  }

  function startPolling() {
    if (pollTimer) clearInterval(pollTimer);
    let attempts = 0;
    pollTimer = setInterval(async () => {
      await syncGifts();
      attempts++;
      if (attempts >= 6) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 1000);
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const result = await originalFetch.apply(this, args);

    if (
      !isSyncing &&
      (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))
    ) {
      startPolling();
    }

    return result;
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button[type="submit"], [data-add-to-cart], [name="add"]');
    if (btn) {
      setTimeout(startPolling, 300);
    }
  }, true);

  syncGifts();
})();